export default {
  // GENERAL 
  DEFAULT: [ 'PENDIENTE', 'EN CURSO', 'FINALIZADA'],
  // WORK ORDER
  WORK_ORDER_STATE: [ 'PENDIENTE', 'EN CURSO', 'FINALIZADA'],
  WORK_ORDER_TYPE_INSPECCION: 1,
  WORK_ORDER_TYPE_REPARACION: 2,
  WORK_ORDER_TYPES: [
    { text: 'Inspección', value: 1 },
    { text: 'Reparación', value: 2 }
  ],
  WORK_ORDER_TYPE: {
    1: 'Inspección',
    2: 'Reparación'
  },
  // INTERVENTION REVIEW
  INTERVENTION_REVIEW_STATES: [
    { text: 'EN CURSO', value: 1 },
    { text: 'LISTA PARA VALIDAR', value: 2 },
    { text: 'EN REVISIÓN', value: 3 },
    { text: 'VALIDADA', value: 4 }
  ],
  INTERVENTION_REVIEW_STATE_ID: {
    1: 'EN CURSO',
    2: 'LISTA PARA VALIDAR',
    3: 'EN REVISIÓN',
    4: 'VALIDADA'
  },
  INTERVENTION_REVIEW_STATE_TEXT: {
    'EN_CURSO': 1,
    'LISTA_PARA_VALIDAR': 2,
    'EN_REVISION': 3,
    'VALIDADA': 4
  },
  INTERVENTION_REVIEW_DAMAGE_LOCATION: {
    VS: 'V.S',
    VP: 'V.P',
    BA: 'B.A',
    BS: 'B.S'
  },
  INTERVENTION_REVIEW_DAMAGE_LOCATIONS: ['V.S', 'V.P', 'B.A', 'B.S'],
  INTERVENTION_REVIEW_DAMAGE_DEGREE: ['Sin daños', 'Leve', 'Medio', 'Grave', 'Muy grave'],
  // REPORTS
  REPORT_STATES: [
    { text: 'Pendiente', value: 1 },
    { text: 'Generando', value: 2 },
    { text: 'Listo para descargar', value: 3 },
    { text: 'Error', value: 4 },
  ],
  REPORT_STATE: {
    1: 'Pendiente',
    2: 'Generando',
    3: 'Listo para descargar',
    4: 'Error'
  },
  REPORT_STATE_COLOR: {
    1: '',
    2: '#2196F3',
    3: '#43A047',
    4: 'error'
  },
  REPORT_TYPES: [
    { text: 'Borrador', value: 'BORRADOR' },
    { text: 'Final', value: 'FINAL' }
  ],
  REPORT_TYPE: {
    BORRADOR: 'Borrador',
    FINAL: 'Final',
  },
  REPORT_LANGUAGES: [
    { text: 'Español', value: 'SPANISH' },
    { text: 'Ingles', value: 'ENGLISH' }
  ],
  REPORT_LANGUAGE: {
    SPANISH: 'Español',
    ENGLISH: 'Ingles',
  },
}